import { getActions } from '../global';
import { getCurrentTabId } from './establishMultitabRole';

// Register link actions before Main bundle loads (welcome modal can show earlier).
import '../global/actions/api/chats';
import '../global/actions/api/messages';

export function openRasiTelegramLink(url: string) {
  const tabId = getCurrentTabId();
  const actions = getActions();

  if (typeof actions.openTelegramLink === 'function') {
    actions.openTelegramLink({ url, tabId });
    return;
  }

  if (typeof actions.openUrl === 'function') {
    actions.openUrl({ url, tabId, shouldSkipModal: true });
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
